import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getTypeCorporate } from '../thunks/commonInfoThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCompanyKey } from '../thunkKeys/commonInfoKeys';

const SLICE_NAME = 'typeCorporate';

export const typeCorporateSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearTypeCorporate(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getTypeCorporate });
        builder.addCase(
            clearCompanyKey,
            () => commonInitialState,
        );
    },
});

export const { clearTypeCorporate } = typeCorporateSlice.actions;

export const typeCorporate = typeCorporateSlice.reducer;
